/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Check_ViolationInputs */

const en_error_check_violation = /** @type {(inputs: Error_Check_ViolationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A value is not allowed.`)
};

/**
* | output |
* | --- |
* | "A value is not allowed." |
*
* @param {Error_Check_ViolationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_check_violation = /** @type {((inputs?: Error_Check_ViolationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Check_ViolationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_check_violation(inputs)
});